import { SimpleDocCommand } from '../../DocsApp/commands/v5/types';
import { StandardToolResult } from '../../../types/standardToolResults';
import { CommandExecutionContext } from '../../../types/commands';
import { validateEntityId, executeWrite } from '../../UniversalCommands/shared/entityWriteCore';
import { formatWriteResult } from '../../../tools/formatWriteResult';

export const playbook_write: SimpleDocCommand = {
  id: 'playbook_write',
  logicalName: 'playbook_write',
  version: 'v2',

  description: 'Write or update a playbook.',

  schema: {
    parameters: [
      {
        name: 'entityId',
        type: 'string',
        description: 'Playbook entity ID (playbook_*)',
        required: true,
        validator: (value: string) => validateEntityId(value, 'playbook_')
      },
      {
        name: 'operation',
        type: 'string',
        description: 'Operation type: insert | replace | update | delete',
        required: true,
        enum: ['insert', 'replace', 'update', 'delete'],
        validator: (value: string) => {
          const validOps = ['insert', 'replace', 'update', 'delete'];
          if (!validOps.includes(value)) return `Invalid operation. Must be one of: ${validOps.join(', ')}`;
          return null;
        }
      },
      {
        name: 'content',
        type: 'object',
        description: 'Content to insert/replace. Format: { className: "playbook-prompt", attrs: { text: "..." } }',
        required: false,
        validator: (value: any, params: any) => {
          if (!value) {
            if (params.operation === 'insert' || params.operation === 'replace' || params.operation === 'update') return `content is required for ${params.operation} operations`;
            return null;
          }
          if (typeof value === 'string') {
            console.warn('[playbook_write] Legacy string format detected. Use { className: "playbook-prompt", attrs: { text: "..." } } instead.');
            return null;
          }
          if (typeof value === 'object') {
            if (value.className && value.className !== 'playbook-prompt') return `Playbooks only support className "playbook-prompt", got "${value.className}"`;
            if (value.className === 'playbook-prompt' && !value.attrs?.text && value.attrs?.text !== '') return 'playbook-prompt requires attrs.text. Example: { className: "playbook-prompt", attrs: { text: "your prompt here" } }';
            if (value.attrs?.text && typeof value.attrs.text !== 'string') return 'attrs.text must be a string';
          }
          return null;
        }
      }
    ]
  },

  formatViewData: (result: any, toolInput: any) =>
    formatWriteResult(result, toolInput, 'playbook'),

  handler: async (params: any, context: CommandExecutionContext): Promise<StandardToolResult> =>
    executeWrite(params, 'playbook', context)
};
